<template>
	<form>
		<div class="row">
			<div class="col-md-12">
				<div
					:class="{
						'text-success': !hasError,
						'text-danger': hasError,
					}"
				>
					{{ notification }}
				</div>
				<button
					class="btn btn-outline-dark float-right"
					@click.prevent="update"
				>
					<span>Save</span>
				</button>
			</div>
			<!-- Left side -->
			<div class="col-md-6">
				<!-- Title -->
				<div class="form-group">
					<label for="frm-name">Title</label>
					<input
						type="text"
						class="form-control"
						id="frm-name"
						name="title"
						v-model="introSoundtrack.title"
					/>
				</div>
				<!-- Description -->
				<div class="form-group">
					<label for="frm-description">Description</label>
					<textarea
						class="form-control"
						id="frm-description"
						name="description"
						v-model="introSoundtrack.description"
					>
					</textarea>
				</div>
				<!-- Is active ? -->
				<div class="form-group">
					<label for="frm-active">Active</label>
					<input
						type="checkbox"
						name="is_active"
						:checked="introSoundtrack.is_active"
						v-model="introSoundtrack.is_active"
					/>
				</div>
				<!-- Sound file -->
				<div class="form-group">
					<button
						type="button"
						v-on:click="uploadAudioFile"
						class="btn btn-primary mb-2"
					>
						<span v-if="introSoundtrack.audio_track"> Replace audio file </span>
						<span v-if="!introSoundtrack.audio_track"> Upload audio file </span>
					</button>
				</div>
				<div class="form-group">
					<div v-if="!introSoundtrack.audio_track">
						<div>No audio track uploaded</div>
						<div>Valid exensions: {{ extensions.join(", ") }}</div>
					</div>
					<div v-if="introSoundtrack.audio_track">
						<div>Audio track has been uploaded.</div>
						<div>Duration: {{ trackTime }}</div>
					</div>
				</div>
			</div>
			<!-- Right side -->
			<div class="col-md-6">
				<label for="">Available docus</label>
				<multiselect
					v-model="selectedStories"
					:options="availableStories"
					:searchable="true"
					track-by="id"
					label="title"
					:multiple="true"
					group-label="label"
					:group-select="true"
					group-values="stories"
					:closeOnSelect="false"
					:taggable="false"
				>
					<template
						slot="selection"
						slot-scope="{ values, search, isOpen }"
						><span
							class="multiselect__single"
							v-if="values.length &amp;&amp; !isOpen"
							>{{ values.length }} options selected</span
						></template
					>
				</multiselect>
			</div>
		</div>
	</form>
</template>

<script>
import Multiselect from "vue-multiselect";
import _ from "lodash";
export default {
	props: {
		introSoundtrack: {
			type: Object,
			required: true,
		},
		stories: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			audioFile: null,
			hasError: false,
			compactLayout: true,
			notification: "",
			extensions: ["m4a", "mp3"],
			selectedStories: this.introSoundtrack.stories,
		};
	},
	components: {
		Multiselect,
	},
	methods: {
		update() {
            if (this.introSoundtrack.full_path) {
                delete(this.introSoundtrack.full_path)
            }

			axios
				.put(`/intro-soundtracks/${this.introSoundtrack.id}`, {
					introSoundtrack: this.introSoundtrack,
					selectedStories: this.selectedStories,
				})
				.then((response) => {
					this.notify("Saved");
				})
				.catch((error) => {
					this.notify("Something went wrong.", true);
					console.error(error);
				});
		},
		uploadAudioFile(e) {
			const input = document.createElement("input");
			input.type = "file";
			input.onchange = (event) => {
				const file = event.target.files[0];
				this.setAudioTrack(file);
			};
			input.click();
		},
		setAudioTrack(track) {
			const reader = new FileReader();

			reader.onload = (e) => {
				const data = e.target.result;
				const filename = track.name;
				axios
					.post(
						`/intro-soundtracks/${this.introSoundtrack.id}/audio`,
						{ filename, data }
					)
					.then((response) => {
						if (
							response.data.audio_track &&
							response.data.duration
						) {
							this.introSoundtrack.audio_track =
								response.data.audio_track;
							this.introSoundtrack.duration =
								response.data.duration;
							this.notify("Success! The audio file was uploaded");
						} else {
							this.notify(
								"Something went wrong. The file was not uploaded.",
								true
							);
						}
					})
					.catch((error) => {
						this.notify(
							"Something went wrong. The file was not uploaded.",
							true
						);
						console.error(error);
					});
			};

			reader.readAsDataURL(track);
		},
		notify(message, error = false) {
			// Set error
			this.hasError = error || false;

			// Display notification
			this.notification = !this.hasError ? "✓ " : "˟ ";
			this.notification += message || "success";

			// Clear after timeout
			setTimeout(() => {
				this.notification = null;
				this.hasError = false;
			}, 3500);
		},
	},
	computed: {
		trackTime: function () {
			const hours = _.floor(this.introSoundtrack.duration / 3600);
			const minutes = _.padStart(
				_.floor((this.introSoundtrack.duration % 3600) / 60),
				2,
				"0"
			);
			const seconds = _.padStart(
				_.floor(this.introSoundtrack.duration % 60),
				2,
				"0"
			);

			if (hours) return `${hours}:${minutes}:${seconds}`;
			return `${minutes} : ${seconds}`;
		},
		availableStories: function () {
			let groups = [
				{
					label: "All docus",
					stories: this.stories,
				},
			];

			return groups;
		},
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tag {
    display: none;
}
</style>
